import { render } from "./pnap.vue?vue&type=template&id=dfb460d8"
import script from "./pnap.vue?vue&type=script&lang=js"
export * from "./pnap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__